import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import numberWithCommas from "../../utils/numbersWithComma";

const WalletCard = () => {
  const { user, wallet } = useSelector((state) => state.auth);

  return (
    <Dropdown className="dropdown-balance">
      <Dropdown.Toggle variant="primary" id="dropdown-balance">
        Bal: {wallet?.balance}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item>
          <div className="bal-type">User</div>
          <div className="bal">{user?.mstruserid}</div>
        </Dropdown.Item>
        <Dropdown.Item>
          <div className="bal-type">Balance</div>
          <div className="bal">{wallet?.balance}</div>
        </Dropdown.Item>
        <Dropdown.Item>
          <div className="bal-type">Cash</div>
          <div className="bal">{numberWithCommas(wallet?.cash)}</div>
        </Dropdown.Item>
        <Dropdown.Item>
          <div className="bal-type">Coins</div>
          <div className="bal">{numberWithCommas(wallet?.coins)}</div>
        </Dropdown.Item>
        {(wallet && "pendingRolloverBonus" in wallet && (
          <Dropdown.Item>
            <div className="bal-type">Locked Bonus</div>
            <div className="bal">
              {numberWithCommas(wallet?.pendingRolloverBonus)}
            </div>
          </Dropdown.Item>
        )) ||
          null}
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default WalletCard;
